import { Box, Button, Container, makeStyles, Chip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import { useDispatch, useSelector } from 'react-redux';
import {
  getClientsAction,
  toggleClientStatusAction
} from 'src/store/actions/ClientManagerActions';
import { Link, useNavigate } from 'react-router-dom';
import CustomDataTable from 'src/components/Table/CustomDataTable';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  datatable: {
    marginTop: theme.spacing(2)
  },
  box: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  table: {
    minWidth: 750
    // minHeight: 500
  }
}));

const ClientManager = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();
  const clients = useSelector((state) => state.Clients.clients);
  const [loading, setLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    async function callGetClients() {
      setLoading(true);
      const response = await dispatch(getClientsAction());

      if (response) {
        setLoading(false);
      }
    }
    callGetClients();
  }, []);

  const handleToggleStatus = async (row) => {
    const { id, accessStatus } = row;
    const status = accessStatus == 1 ? 0 : 1;
    const toggle = window.confirm(
      'Are you sure you want to toggle this client status?'
    );
    if (toggle) {
      setButtonLoader(true);
      const response = await dispatch(
        toggleClientStatusAction(id, { accessStatus: status })
      );
      if (response) setButtonLoader(false);
    }
  };

  const tableConfig = [
    {
      title: 'S/N',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'Fullname',
      value: 'fullname',
      align: 'center'
    },
    {
      title: 'Email',
      value: 'email',
      align: 'center'
    },
    {
      title: 'Phone',
      value: 'phone',
      align: 'center'
    },
    {
      title: 'Total Point',
      value: 'totalPoint',
      align: 'center',
      render: (row) => row.totalPoint
    },
    {
      title: 'Points Left',
      value: 'pointLeft',
      align: 'center',
      render: (row) => row.pointLeft
    },

    {
      title: 'Status',
      value: 'accessStatus',
      align: 'center',
      render: (row, i) =>
        row.accessStatus == 0 ? (
          <Chip
            variant="outlined"
            color="primary"
            size="small"
            label="Deactivated"
          />
        ) : (
          <Chip
            style={{ background: 'green', color: 'white' }}
            size="small"
            label="Active"
          />
        )
    },
    {
      title: 'Total Staffs',
      value: 'staff',
      align: 'center',
      render: (row, i) => <p> {row?.staffs?.length || 0}</p>
    },
    {
      title: 'Actions',
      value: '',
      align: 'center',
      render: (row, i) => (
        <Box>
          <Button
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            size="small"
            onClick={(e) => navigate('/register', { state: row })}
          >
            Update
          </Button>
          {/* <Button
            id="reset-password"
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            // onClick={() => handleResetPassword(row.id)}
          >
            Reset Password
          </Button> */}
          &nbsp;
          <Button
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => handleToggleStatus(row)}
          >
            {row?.accessStatus == 1 ? 'Disable Account' : 'Enable Account'}
          </Button>
          &nbsp;
          <Button
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => {
              navigate('/client-manager/staffs', { state: row });
            }}
          >
            Staffs
          </Button>
        </Box>
      )
    }
  ];

  const tableActions = () => (
    <Box className={classes.box}>
      <Link to="/register">
        <Button variant="contained" color="primary">
          Onboard New Client
        </Button>
      </Link>
    </Box>
  );
  return (
    <>
      <Page className={classes.root} title="Client Manager">
        <Container maxWidth="lg">
          <Box>
            <CustomDataTable
              className={classes}
              tableData={clients}
              tableConfig={tableConfig}
              tableActions={tableActions}
              loading={loading}
              filterField="fullname"
            />
          </Box>
        </Container>
      </Page>
    </>
  );
};

export default ClientManager;
